import knowledgeServiceApi from 'shared/api/knowledge.service.api';
import { EVENTS } from 'shared/constants';
import analyticsService from 'src/helpers/analytics.service';

export async function openInNewTab({ id, title, link, content }) {
  analyticsService.track(EVENTS.KNOWLEDGE_ITEMS.OPEN_IN_NEW_TAB, {
    id,
    link,
    title,
  });
  if (content && !link) {
    const res = await knowledgeServiceApi.getItemContentAsPDF({ id });
    link = res.data.url;
  }
  window.open(link);
}